import { NumberInShapeComponent } from '~/_shared/baseComponents/numberInShape/numberInShape.component';
import { TooltipComponent } from '~/_shared/baseComponents/tooltip/tooltip.component';
import { useHover } from '~/_shared/hooks/interaction/useHover';
import { TooltipPlacement } from '~/_shared/utils/placement.util';
import {
  getBrighterColor, getFontColor, ITEM_SIZE, itemStyle,
} from '~/map/mapToolControls/menuItems/overlappingUI/overlappingUI.styles';
import type { OverlappingMapElement } from '~/map/mapToolControls/menuItems/overlappingUI/overlappingUI.types';

type OverlappingUIPanelItemComponentProps = Readonly<{
  item: OverlappingMapElement;
}>;

export const OverlappingUIPanelItemComponent = ({
  item,
}: OverlappingUIPanelItemComponentProps) => {
  const { hoverProps } = useHover({
    onHoverStart: item.onHoverStart,
    onHoverEnd: item.onHoverEnd,
  });

  return (
    <TooltipComponent
      placement={TooltipPlacement.Right}
      tooltipContent={item.name}
    >
      <span
        onClick={item.onClick}
        {...hoverProps}
      >
        <NumberInShapeComponent
          shape={item.shape}
          colors={{
            fontColor: item.fontColor ?? getFontColor(item.backgroundColor),
            fillColor: item.active ? getBrighterColor(item.backgroundColor).hex : item.backgroundColor,
          }}
          css={itemStyle(item.backgroundColor, item.active, item.label.toString().length)}
          size={ITEM_SIZE}
        >
          {item.label}
        </NumberInShapeComponent>
      </span>
    </TooltipComponent>
  );
};
